<template>
  <v-container id="docForm">
    <v-row dense id="po" class="subtitle-2 text--primary">
      <v-col cols="12" md="3">
        <span style="font-weight: bold; font-size: 16px">Journal#: {{ DocNum }}</span>
      </v-col>

      <v-col cols="12" md="5">
        <v-text-field
              label="Narration / Title"
              autocomplete="off"
              style="min-width: 100px"
              class="orderInput"
              single-line
              outlined
              dense
              v-model="narration"
            ></v-text-field>
      </v-col>

      <v-col cols="12" md="3" offset-md="1">
        <DatePicker @date="setDate" :myDate="date" :title="`Date`"></DatePicker>
      </v-col>

      <v-col cols="12">
        <v-data-table
          light
          dense
          :items-per-page="pageItems"
          :headers="headers"
          :items="orderItems"
          item-key="LineNum"
          hide-default-footer
          disable-sort
        >
          <template v-slot:item.Name="{ item }">
            <v-autocomplete
              style="min-width: 250px"
              autocomplete="off"
              dense
              outlined
              single-line
              v-model="item.id"
              :items="accounts"
              label="Select Account"
              item-text="Name"
              item-value="id"
              @change="setOrderItem(item)"
            >
              <template v-if="enableCreate" v-slot:no-data>
                <v-row align="center" justify="center">
                  <v-btn
                    :loading="searchingProduct"
                    class="ma-2"
                    color="accent"
                    dark
                    small
                    elevation="0"
                    @click="openCreate(item)"
                  >
                    <v-icon left>mdi-plus</v-icon>Create Account
                  </v-btn>
                </v-row>
              </template>
            </v-autocomplete>
          </template>

          <template v-slot:item.Debit="{ item }">
            <v-text-field
              autocomplete="off"
              type="number"
              style="min-width: 100px"
              class="orderInput"
              single-line
              outlined
              dense
              v-model="item.Debit"
            ></v-text-field>
          </template>

          <template v-slot:item.Credit="{ item }">
            <v-text-field
              autocomplete="off"
              type="number"
              style="min-width: 100px"
              class="orderInput"
              single-line
              outlined
              dense
              v-model="item.Credit"
            ></v-text-field>
          </template>

          <template v-slot:item.Narration="{ item }">
            <v-text-field
              autocomplete="off"
              type="text"
              style="min-width: 280px"
              class="orderInput"
              single-line
              outlined
              dense
              v-model="item.Narration"
            ></v-text-field>
          </template>

          <!-- action template -->
          <template v-slot:item.action="{ item }">
            <v-btn @click="deleteRow(item)" color="red" icon>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
          <!-- end -->
        </v-data-table>

        <!-- Totals table -->
        <v-data-table
          light
          dense
          :items-per-page="pageItems"
          :headers="totalHeaders"
          :items="totalsData"
          item-key="LineNum"
          hide-default-footer
          hide-default-header
        >
          <template v-slot:item.Name="{ item }">
            <div
              style="
                font-size: 16px;
                font-weight: bold;
                min-width: 110px;
                float: right;
                color: #696969;
              "
            >Totals:</div>
          </template>

          <template v-slot:item.Debit="{ item }">
            <div
              style="
                min-width: 70px;
                font-size: 16px;
                font-weight: bold;
                color: #696969;
              "
            >DR: {{ totalDebit.toLocaleString() }}</div>
          </template>

          <template v-slot:item.Credit="{ item }">
            <div
              style="
                min-width: 100px;
                font-size: 16px;
                font-weight: bold;
                color: #696969;
              "
            >CR: {{ totalCredit.toLocaleString() }}</div>
          </template>

          <template v-slot:item.Narration="{ item }">
            <div style="min-width: 70px"></div>
          </template>
        </v-data-table>
        <!-- end -->

        <v-btn @click="addRow" text color="primary" class="mt-1">
          <v-icon left>mdi-plus</v-icon>Add Journal Row
        </v-btn>
      </v-col>
    </v-row>

    <v-row class="subtitle-2 text--primary flex justify-end">
      <v-col cols="12" class="d-flex justify-end">
        <v-btn color="primary" @click="sendData" :loading="$store.state.btnLoader">
          <v-icon left>mdi-content-save</v-icon>Post Journal
        </v-btn>
      </v-col>
    </v-row>

    <!-- Payment dialog -->
    <v-dialog v-model="deleteDialog" max-width="700px">
      <v-card>
        <v-toolbar dense color="red" dark>
          <v-toolbar-title>Remove Row</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="deleteDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-col cols="12">
                <span
                  v-if="activeDeleteRow != null"
                  style="font-size: 16px; font-weight: bold"
                >{{ activeDeleteRow.Name }}</span>
                <v-alert v-else border="top" colored-border type="info" elevation="2">Empty Row!</v-alert>
              </v-col>

              <v-col cols="12">
                <v-btn color="red" dark @click="deleteRow(activeDeleteRow)" :loading="loader">
                  <v-icon left>mdi-delete</v-icon>Remove
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of transfer modal-->

    <!-- Account quick add dialog -->
    <v-dialog v-model="accountDialog" max-width="650px">
      <v-card>
        <v-toolbar dense color="primary" dark>
          <v-toolbar-title>Create Account</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="accountDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <account-editor :initial="accountItem" @data="saveAccount"></account-editor>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of modal-->

    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>


<script>
// import moment from 'moment-timezone';
import AccountEditor from "@/components/subscriber/accounts/_components/quick-editor.vue";
export default {
  components: {
    AccountEditor
  },
  props: {
    docCreate: {
      type: Boolean
    },
    loaderOff: {
      type: Boolean
    },
    copyStatus: {
      type: Boolean
    }
  },
  data: () => ({
    record: {},
    narration: null,
    accountItem: {},
    quickItem: {},
    enableCreate: true,
    searchingProduct: false,
    UserSign: null,
    deleteName: null,
    deleteDialog: false,
    activeDeleteRow: {},
    enablePriceList: "N",
    ref2: null,
    IMEI: null,
    SoldBy: null,
    loader: false,
    pageItems: 100,
    DiscOnTotal: null,
    AmountGiven: null,
    multiplePayment: "Y",
    selectedProduct: null,
    SumApplied: null,
    DocNum: null,
    selectedItems: [],
    activeRow: null,
    storeId: null,
    singleSelect: true,
    paymentItem: {},
    paymentDialog: false,
    changeCash: 0,
    payments: [],
    orderItems: [],
    customers: [],
    products: [],
    accounts: [],
    taxGroups: [],
    accountBalances: [],
    stores: [],
    users: [],
    accountDialog: false,
    date: null,
    totalsData: [{ Name: "", Debit: "", Credit: "", Narration: "" }],
    headers: [
      { text: "Account", value: "Name" },
      { text: "Debit", value: "Debit" },
      { text: "Credit", value: "Credit" },
      { text: "Narration", value: "Narration" },
      { text: "Delete", value: "action" }
    ],
    totalHeaders: [
      { text: "Account", value: "Name" },
      { text: "Debit", value: "Debit" },
      { text: "Credit", value: "Credit" },
      { text: "Narration", value: "Narration" }
      // { text: "Delete", value: "action" }
    ]
  }),
  computed: {
    userName() {
      return localStorage.getItem("userName");
    },
    activeStore() {
      return localStorage.getItem("store_id");
    },
    totalCredit() {
      let total = 0;
      if (typeof this.orderItems != "undefined" && this.orderItems.length > 0) {
        return this.orderItems
          .map(item => {
            const amount = item.Credit;
            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    },
    totalDebit() {
      let total = 0;
      if (typeof this.orderItems != "undefined" && this.orderItems.length > 0) {
        return this.orderItems
          .map(item => {
            const amount = item.Debit;
            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    }
  },
  methods: {
    openCreate(data) {
      this.quickItem = data;
      this.accountDialog = true;
    },
    saveAccount(data) {
      const url = "/accounts";
      const self = this;
      self.$store.commit("btnLoader", true);
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.quickAdd(res.ResponseData);
            self.loader = false;
            self.$store.commit("btnLoader", false);
            self.accountDialog = false;
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    quickAdd(account) {
      this.accounts = [...this.accounts, account];
      // current item definition
      const self = this;
      const currentItem = this.orderItems.find(record => {
        return record.LineNum === self.quickItem.LineNum;
      });
      const pos = this.orderItems.indexOf(currentItem);
      if (pos === -1) {
        return;
      }
      currentItem.id = account.id;
      this.orderItems[pos] = currentItem;
      this.accountItem = {};
      this.$refs.snackbar.show("Added Successully", "green");
    },
    deleteAccount(item) {
      const selectedRow = this.payments.find(record => {
        return record.o_a_c_t_s_id === item.o_a_c_t_s_id;
      });
      const pos = this.payments.indexOf(selectedRow);
      if (pos === -1) {
        return;
      }
      this.payments.splice(pos, 1);
    },
    setDate(date) {
      this.date = date;
    },
    deleteRow(item) {
      const selectedRow = this.orderItems.find(record => {
        return record.LineNum === item.LineNum;
      });
      const pos = this.orderItems.indexOf(selectedRow);
      if (pos === -1) {
        return;
      }
      this.orderItems.splice(pos, 1);
      this.activeRow = null;
      this.selectedItems = [];
      this.deleteDialog = false;
    },
    selectedRow($event) {
      this.activeDeleteRow = $event.item;
      this.deleteDialog = true;
    },
    setOrderItem(data) {
      const store_id = this.activeStore;
      // current item definition
      const currentItem = this.orderItems.find(record => {
        return record.LineNum === data.LineNum;
      });
      const pos = this.orderItems.indexOf(currentItem);
      if (pos === -1) {
        return;
      }
      currentItem.store_id = store_id;
      this.orderItems[pos] = currentItem;
    },
    sendData() {
      if (this.narration == null || this.narration == undefined) {
        this.$refs.snackbar.show("Please fill the journal title / narration", "red");
        return;
      } 

      if (this.date == null || this.date == undefined) {
        this.$refs.snackbar.show("Please select date!", "red");
        return;
      }

      if (this.orderItems.length < 2) {
        this.$refs.snackbar.show("You must have at least two entry record", "red");
        return;
      }

      let data = {};
      data.date = this.date;
      data.narration = this.narration;
      var journalRows = [];
      for(const row of this.orderItems) {
       if(row.id == undefined) {
          this.$refs.snackbar.show("There is a row without gl / account", "red");
          return;
       }
       
        if(row.Debit == null && row.Credit == null) {
          this.$refs.snackbar.show("Both debit and credit for each row cannot be empty", "red");
          return;
        }

        var debit = 0.0;
        var credit = 0.0;

        if(row.Debit != null) {
          debit = parseFloat(row.Debit);
        }

        if(row.Credit != null) {
          credit = parseFloat(row.Credit);
        }

        if(debit > 0  && credit > 0) {
          this.$refs.snackbar.show("Both debit and credit cannot have values for one row", "red");
          return;
        }

        var details = {
          glAccount: row.id,
          debit: debit,
          credit: credit,
          narration: row.Narration
        };

        journalRows.push(details);
      }

      data.journal_entry = journalRows; 

      if (this.totalCredit != this.totalDebit) {
        this.$refs.snackbar.show("Debit must be equal to credit", "red");
        return;
      }

      // save data
      const url = "/journal-entry";
      const self = this;
      self.$store.commit("btnLoader", true);
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.getDocNum();
            self.date = null;
            self.$store.commit("btnLoader", false);
            self.orderItems = [];
            this.$refs.snackbar.show("Posted Successfully", "green");
            self.date = null;
            self.record = {};
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
      // end
    },
    getDocNum() {
      const self = this;
      this.$store
        .dispatch("get", `/document-numbering/14`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.DocNum = res.ResponseData.NextNumber;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getAccounts() {
      const self = this;
      this.$store
        .dispatch("get", `/accounts`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.accounts = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    addRow() {
      let initArray = [];
      const LineNum = new Date().getTime();
      const details = {
        LineNum: LineNum,
        Name: null,
        Credit: null,
        Debit: null,
        Narration: null
      };
      initArray.push(details);
      this.orderItems = [...this.orderItems, ...initArray];
    },
    setDefaultRow() {
      const LineNum = new Date().getTime();
      let initArray = [];
      const details = {
        LineNum: LineNum,
        Name: null,
        Credit: null,
        Debit: null,
        Narration: null
      };
      initArray.push(details);
      this.orderItems = [...this.orderItems, ...initArray];
    },
    getAccountBalances() {
      const self = this;
      this.$store
        .dispatch("get", `/account-balances`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.accountBalances = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    this.setDefaultRow();
    Promise.all([
      this.getDocNum(),
      this.getAccounts(),
      this.getAccountBalances()
    ]);
  }
};
</script>

<style lang="scss" scoped>
.genFont {
  font-size: 1.3em;
  font-weight: 500;
}
</style>